import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { createSelector } from 'reselect';
import { toggleFolderModal } from '../../slices/modals/reducer';
import FolderItem from './FolderItem';
import SelectedItem from './SelectedItem';
import { removeSelectedItem, resetSelectedItems, setFolders } from '../../slices/folder/reducer';
import { getFolderInFolderThunk, getFolderRootThunk, moveAllItemsToFolder, moveItemToFolder, setFolderHistory, } from '../../slices/folder/thunk';
import { getFeeds } from '../../slices/feeds/thunk';
import { getCampaigns } from '../../slices/campaigns/thunk';

function FolderModal() {
  const dispatch = useDispatch();
  // Select Folder Modal State
  const selectFolderModalState = createSelector((state) => state.Modal, (state) => state.folderModal);
  const folderModal = useSelector(selectFolderModalState);
  const selectFolderItemState = createSelector((state) => state.Folder, (state) => ({
    folders: state.folders,
    folderRootPath: state.folderRootPath, 
    folderHistory: state.folderHistory,
    selectedItems: state.selectedItems,
  }));
  const { folders, folderRootPath, folderHistory, selectedItems } = useSelector(selectFolderItemState);
  const selectMarket = createSelector((state) => state.MenuData, (state) => ({
    marketPath: state.marketPath
  }));
  const {marketPath} = useSelector(selectMarket);

  const [folderState, setFolderState] = useState([]);
  
  useEffect(() => {
    if (Array.isArray(folders) && folders.length > 0) {
      if (folders[0].type === 'campaign') {
        setFolderState(folders.filter(item => item.marketId === marketPath));
      } else if (folders[0].type === 'feed') {
        setFolderState(folders)
      } 
    } else {
      setFolderState([]);
    }
  }, [folders]);

  function closeModal() {
    dispatch(toggleFolderModal());
    setTimeout(() => {
      // Clear State
      dispatch(setFolderHistory([]));
      dispatch(setFolders(null));
    }, 300);
  }

  async function openSubFolder(item, history = null) {
    if (history) {
      dispatch(setFolderHistory([...history, item]));
    } else {
      dispatch(setFolderHistory([...folderHistory, item]));
    }
    await dispatch(getFolderInFolderThunk(item._id));
  }

  async function handleHistory(item, idx) {
    if (item.hasOwnProperty("_id")) {
      dispatch(setFolderHistory(folderHistory.slice(0, idx))).then(res => {
        openSubFolder(item, res.payload);
      });
    } else {
      dispatch(setFolderHistory([folderHistory[0]]));
      dispatch(getFolderRootThunk());
    }
  }

  async function moveSingle(item) {
    await dispatch(moveItemToFolder({item: item, folder: folderHistory[folderHistory.length - 1]}));
    dispatch(removeSelectedItem(item._id));
    closeModal();
    // await getItems();
  }
  
  async function moveAll() {
    await dispatch((moveAllItemsToFolder()));
    closeModal();
    // await getItems();
    dispatch(resetSelectedItems());
  }

  async function getItems() {
    if (folderRootPath === "campaign") {
      await dispatch(getCampaigns());
    } else if (folderRootPath === "feed") {
      await dispatch(getFeeds());
    }
  }
 
  return (
    <Modal isOpen={folderModal} toggle={closeModal} centered size="md">
      <ModalHeader className='p-3' toggle={closeModal}>
        Move to
      </ModalHeader>
      <ModalBody className='px-0 pt-0'>
        {folderHistory.length > 1 ?
          <div className='w-100 pt-3 pb-1 px-3 d-flex align-items-center flex-wrap user-select-none'>
            {(folderHistory || []).map((item, idx) => {
              let lastItemIdx = folderHistory.length - 1;
              return (
                <React.Fragment key={idx}>
                  <p className={'m-0 cursor-pointer' + (idx === lastItemIdx ? ' text-muted fw-bold' : ' ')}
                  onClick={() => handleHistory(item, idx)}>{item.name}</p>
                  {idx !== lastItemIdx ?
                    <i className='ri-arrow-right-s-line align-center fs-4 text-muted mx-2'></i>
                    : null}
                </React.Fragment>
              )
            })}
          </div>
          : null}
        <div className='w-100 py-3 px-3 d-flex align-items-center justify-content-between border-bottom text-muted'>
          <p className='m-0'>Folder Name</p>
          <p className='m-0'>Modified</p>
        </div>
        {(folderState || []).map((folder, idx) => {
          if (selectedItems.find(item => item._id === folder._id)) {
            return null;
          } else {
            return (
              <FolderItem key={idx} name={folder.name} date={folder.modifiedDate} handleClick={() => openSubFolder(folder)} />
            )
          }
        })}
        <div className='w-100 d-flex flex-column gap-2 py-3 px-3 d-flex'>
          {(selectedItems || []).map((item, idx) => {
            return (
              <SelectedItem key={idx} {...item} onClick={() => moveSingle(item)} />
            )
          })}
        </div>
      </ModalBody>
      <ModalFooter className='d-flex align-items-center justify-content-end gap-1'>
        <button type="button" className='btn btn-light' onClick={closeModal}>Close</button>
        <button type="button" className='btn btn-info' onClick={moveAll}>Move</button>
      </ModalFooter>
    </Modal>
  )
}

export default FolderModal;